module.exports = __webpack_public_path__ + "static/img/witness-kids-8.6e1257f1.png";